import { render, staticRenderFns } from "./SupervisionLevelChip.vue?vue&type=template&id=239c8394&"
import script from "./SupervisionLevelChip.vue?vue&type=script&lang=js&"
export * from "./SupervisionLevelChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports